import React from 'react';

const LegacyLinkedinIcon = () => {
  return (
    <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.1999 4.87305C12.4729 4.87305 13.6938 5.37876 14.594 6.27893C15.4942 7.17911 15.9999 8.40001 15.9999 9.67305V15.273H12.7999V9.67305C12.7999 9.2487 12.6313 8.84173 12.3313 8.54168C12.0312 8.24162 11.6242 8.07305 11.1999 8.07305C10.7756 8.07305 10.3686 8.24162 10.0685 8.54168C9.76847 8.84173 9.5999 9.2487 9.5999 9.67305V15.273H6.3999V9.67305C6.3999 8.40001 6.90562 7.17911 7.80579 6.27893C8.70596 5.37876 9.92686 4.87305 11.1999 4.87305Z"
        fill="white"
      ></path>
      <path d="M3.2 5.67285H0V15.2729H3.2V5.67285Z" fill="white"></path>
      <path
        d="M1.6 3.27324C2.48366 3.27324 3.2 2.5569 3.2 1.67324C3.2 0.789587 2.48366 0.0732422 1.6 0.0732422C0.716344 0.0732422 0 0.789587 0 1.67324C0 2.5569 0.716344 3.27324 1.6 3.27324Z"
        fill="white"
      ></path>
    </svg>
  );
};

export default LegacyLinkedinIcon;
